import { render, staticRenderFns } from "./NameProfile.vue?vue&type=template&id=4a38be4e&scoped=true&"
import script from "./NameProfile.vue?vue&type=script&lang=js&"
export * from "./NameProfile.vue?vue&type=script&lang=js&"
import style0 from "./NameProfile.vue?vue&type=style&index=0&id=4a38be4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a38be4e",
  null
  
)

export default component.exports